import { render, staticRenderFns } from "./chinaAndRussia.vue?vue&type=template&id=0ffa6489&"
import script from "./chinaAndRussia.vue?vue&type=script&lang=js&"
export * from "./chinaAndRussia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports